module.exports = __webpack_public_path__ + "static/media/kingsfoodmarkets.672850e3.svg";